import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Tjenester',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terrasse tilgængelig',
    [STORE_SERVICES.DINE_IN]: 'Spisning på stedet',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Onlinebestilling via FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Reservationer via FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reservationer i restauranten',
  },
  labels: {
    reservation_total_seats: 'Samlet antal pladser til reservation',
    catering_min_people: 'Minimum antal personer til catering',
  },
};
